/* Arkhades — étoiles des cartes produit alignées sur le bloc « review-line » des pages produit :
   carré PLEIN (vert #00b67a rempli au prorata de la note, gris #dddddd pour le reste) avec l'étoile
   blanche découpée par-dessus. Remplace le rendu de l'app d'avis, qui n'affichait qu'une pastille
   arrondie gris très clair pour les étoiles non acquises (effet « case vide »). */
(function () {
  var GREEN = "#00b67a", GREY = "#dddddd", SIZE = 16, N = 0;
  var STAR = "M9.20283 27L16.001 21.807L22.7972 27L20.2018 18.596L27 13.403H18.5984L16.001 5L13.4037 13.403H5L11.7982 18.596L9.20283 27Z";
  function starSvg(pct) {
    var id = "ark-star-" + (++N);
    return '<svg class="ark-star" width="' + SIZE + '" height="' + SIZE + '" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<defs><linearGradient id="g' + id + '">' +
        '<stop offset="0%" stop-color="' + GREEN + '"></stop>' +
        '<stop offset="' + pct + '%" stop-color="' + GREEN + '"></stop>' +
        '<stop offset="' + pct + '%" stop-color="' + GREY + '"></stop>' +
        '<stop offset="100%" stop-color="' + GREY + '"></stop>' +
      '</linearGradient>' +
      '<clipPath id="c' + id + '"><rect width="22" height="22" fill="#fff" transform="translate(5 5)"></rect></clipPath></defs>' +
      '<rect width="32" height="32" fill="url(#g' + id + ')"></rect>' +
      '<g clip-path="url(#c' + id + ')"><path d="' + STAR + '" fill="#ffffff"></path></g></svg>';
  }
  function render(box) {
    if (box.getAttribute("data-ark") === "1") return;
    var rating = parseFloat(box.getAttribute("rating") || box.getAttribute("data-rating") || "0");
    if (!rating || rating < 0 || rating > 5) return;
    var reviews = box.getAttribute("data-review-num") || "";
    var html = "";
    for (var i = 0; i < 5; i++) {
      var pct = Math.max(0, Math.min(100, Math.round((rating - i) * 100)));
      html += starSvg(pct);
    }
    if (reviews) html += '<span class="ark-star-count">(' + reviews + ')</span>';
    box.setAttribute("data-ark", "1");
    box.innerHTML = html;
  }
  function scan() {
    var boxes = document.querySelectorAll(".vstar-star[rating], .collection-icon-list[rating]");
    for (var i = 0; i < boxes.length; i++) render(boxes[i]);
  }
  var css = document.createElement("style");
  css.textContent = ".vstar-star[data-ark],.collection-icon-list[data-ark]{display:flex;align-items:center;gap:2px;line-height:1}" +
    ".vstar-star[data-ark] .ark-star,.collection-icon-list[data-ark] .ark-star{display:block}" +
    ".ark-star-count{margin-left:6px;font-size:13px;color:#6b6b6b}";
  document.head.appendChild(css);
  scan();
  document.addEventListener("DOMContentLoaded", scan);
  new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(scan, 1500); setTimeout(scan, 4000);
})();